import { IScenarioDrillFracOverlap } from '../../interfaces/iscenario-drill-frac-overlap';
import { DrillGroup } from '../drill-group';
import { FracGroup } from '../frac-group';
import { Scenario } from '../scenario';

export class ScenarioDrillFracOverlapBase {
  ScenarioDrillFracOverlapId: number;
  ScenarioId: number | null;
  DrillGroupId: number | null;
  FracGroupId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  DrillGroup?: DrillGroup;
  FracGroup?: FracGroup;
  Scenario?: Scenario;

  constructor(item?: IScenarioDrillFracOverlap) {
    if (item) {

      this.ScenarioDrillFracOverlapId = item.ScenarioDrillFracOverlapId;
      this.ScenarioId = item.ScenarioId;
      this.DrillGroupId = item.DrillGroupId;
      this.FracGroupId = item.FracGroupId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.DrillGroup = new DrillGroup(item.DrillGroup);
      this.FracGroup = new FracGroup(item.FracGroup);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}